<ng-container *ngIf="serverError">
  <div class="modal-header">
    <h4 class="modal-title">Server Error: {{ serverError }}</h4>
    <button type="button" class="close" aria-label="Close" (click)="this.activeModal.close()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
</ng-container>

<ng-container *ngIf="!serverError">
  <div class="modal-header">
    <h4 class="modal-title">
      Select Payment Method
    </h4>
    <button type="button" class="close" aria-label="Close" (click)="this.activeModal.close()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body" *ngIf="loadingPayment">
    <div class="alert alert-info mb-0">Loading...</div>
  </div>

  <div class="modal-body" *ngIf="cannotPayErrorMessage">
    <div class="alert alert-danger mb-0">
      {{ cannotPayErrorMessage }}
    </div>
  </div>

  <div class="modal-body" *ngIf="!loadingPayment && (cannotPayErrorMessage === '')">
    <ng-container *ngIf="!useSavedSelected">
      <button class="btn btn-block btn-primary"
              (click)="handleManualCardEntry()">
        Manual Card Entry
      </button>
      <button class="btn btn-block btn-primary"
              *ngIf="hasCardReaderOption()"
              (click)="handleCardReader()">
        Card Reader
      </button>
      <button class="btn btn-block btn-primary"
              [disabled]="loadingInvoice || loadingPaymentMethods || (customerPaymentMethods.length === 0)"
              [class.disabled]="loadingInvoice || loadingPaymentMethods || (customerPaymentMethods.length === 0)"
              (click)="useSavedSelected = true">
        Use Saved Card
        <ng-container *ngIf="loadingInvoice || loadingPaymentMethods">
          - Loading
        </ng-container>
        <ng-container *ngIf="!(loadingInvoice || loadingPaymentMethods)">
          ({{ customerPaymentMethods.length }} available)
        </ng-container>
      </button>
      <button class="btn btn-block btn-primary"
              [disabled]="!canUseAccountCredit()"
              [class.disabled]="!canUseAccountCredit()"
              (click)="handleAccountCredit()">
        {{ accountCreditLabel() }}
      </button>
    </ng-container>
    <ng-container *ngIf="useSavedSelected">
      <div class="mb-3">
        <label for="selectedPaymentMethod">Saved Card</label>
        <select class="custom-select"
                id="selectedPaymentMethod"
                name="selectedPaymentMethod"
                [(ngModel)]="selectedPaymentMethod">
          <option *ngFor="let cpm of customerPaymentMethods"
                  [ngValue]="cpm">
            {{ cpm.brand ? capitalizeFirstLetter(cpm.brand) : 'Card' }}
            ending in {{ cpm.last4 ? cpm.last4 : '(Unknown)' }}
            (exp. {{ cpm.exp_month ? cpm.exp_month : '??' }}/{{ cpm.exp_year ? cpm.exp_year : '????' }})
          </option>
        </select>
      </div>
      <button class="btn btn-block btn-primary"
              (click)="handleSavedCard()">
        Make Payment
      </button>
      <button class="btn btn-block btn-secondary"
              (click)="useSavedSelected = false;">
        Back
      </button>
    </ng-container>

    <div *ngIf="creditAppliedMessage" class="alert alert-success mt-3 mb-0">
      {{ creditAppliedMessage }}
    </div>

    <div *ngIf="errorMessage" class="alert alert-danger mt-3 mb-0">
      {{ errorMessage }}
    </div>
  </div>

  <!-- Outside the loadingPayment block so a recheck's "Checking..." stays visible. -->
  <div class="modal-body pt-0" *ngIf="liveReaderRefusal">
    <app-live-reader-refusal-alert [refusal]="liveReaderRefusal"
                                   alertClass="alert-danger mb-0">
    </app-live-reader-refusal-alert>
  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-secondary"
            (click)="this.activeModal.close()">
      Cancel
    </button>
  </div>
</ng-container>
